module.exports = __webpack_public_path__ + "media/luxury-2026/parsonage-estate-exterior-960-782812ca.jpg";